import { defineComponent as _defineComponent } from 'vue'

/* Category Page
 *
 * @parent:
 * @requests:
 * @events:
 * @props:
 * @components:
 * @methods:
 */

const __default__ = {
  name: 'CategoryPage',
};

import { computed, onMounted, useContext, useStore } from '@nuxtjs/composition-api';

import ExpandableDescription from '~/components/category/ExpandableDescription.vue';
import ResourcesList from '~/components/resource/ResourcesList.vue';
import CountrySwitcher from '~/components/CountrySwitcher.vue';
import TBreadcrumbs from '~/components/atoms/t-breadcrumbs.vue';
import FilteredPageLinks from '~/components/category/FilteredPageLinks.vue';
import AuthorToolbar from '~/components/AuthorToolbar.vue';
import CategoryNav from '~/components/category/CategoryNav.vue';
import LocalVersionBanner from '~/components/resource/LocalVersionBanner.vue';

import { FilterInfo } from '~/types/api';
import {
  breadcrumbs as normalisedBreadCrumbs,
  BreadCrumb,
  longCategoryTitle,
} from '~/utils/category';

export interface ResourceParams {
  category: string;
  perPage: number;
  resource_types?: string[];
  year_levels?: string[];
  root?: string;
}

export interface Parent {
  link: string;
  name: string;
}

export interface CategoryPageProps {
  subtitle?: string;
  headerImage?: string;
  availableFilters?: string[];
  additionalPath?: string;
  parent?: Parent;
  resourceParams: ResourceParams;
  yearLevel?: string; // If this is a filtered category page by year level
  resourceType?: string; // If this is a filtered category page by resource type
  filteredResourceTypes?: FilterInfo[];
  filteredYearLevels?: FilterInfo[];
  filteredLandingPage?: boolean;
  translatedDescription?: string;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    subtitle: { default: undefined },
    headerImage: { default: undefined },
    availableFilters: { default: () => [
    'types',
    'learning_areas',
    'year_levels',
    'resource_types',
    'availability',
    'file_formats',
    'publishers',
  ] },
    additionalPath: { default: undefined },
    parent: { default: undefined },
    resourceParams: null,
    yearLevel: { default: undefined },
    resourceType: { default: undefined },
    filteredResourceTypes: { default: undefined },
    filteredYearLevels: { default: undefined },
    filteredLandingPage: { type: Boolean, default: false },
    translatedDescription: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { subtitle: string, headerImage: string, availableFilters: string[], additionalPath: string, parent: Parent, resourceParams: ResourceParams, yearLevel: string, resourceType: string, filteredResourceTypes: FilterInfo[], filteredYearLevels: FilterInfo[], filteredLandingPage: boolean, translatedDescription: string };



const store = useStore();
const { i18n, $constructEventParamsCategory, $mzAnalyticsApi } = useContext();

// Computed
const loggedInUser = computed(() => store.getters.loggedInUser);
const category = computed(() => store.getters.category);
const title = computed<string>(() => {
  return longCategoryTitle(category.value.name, i18n.locale, props.resourceType, props.yearLevel);
});
const subtitle = computed<string | null>(() => {
  return props.subtitle || category.value.subtitle;
});
const description = computed(() => {
  if (props.filteredLandingPage) {
    return null;
  }

  if (props.translatedDescription) {
    return props.translatedDescription;
  }

  return category.value.description ?? null;
});

const breadcrumbs = computed<BreadCrumb[]>(
  () => normalisedBreadCrumbs(category.value?.breadcrumbs, props.parent) ?? []
);

const hideNavigation = computed(() => {
  /* Although resource availability category has 2 children - free and premium
   * we don't want to show links to premium from free
   */
  return category.value?.root?.slug === 'resource-availability';
});

// Mounted
onMounted(() => {
  if (!(category.value.event_params.Page_Type_Name === 'Resource Availability')) {
    $mzAnalyticsApi({
      event: 'pageView',
    });
  }
});

return { __sfc: true,props, store, i18n, $constructEventParamsCategory, $mzAnalyticsApi, loggedInUser, category, title, subtitle, description, breadcrumbs, hideNavigation, ExpandableDescription, ResourcesList, CountrySwitcher, TBreadcrumbs, FilteredPageLinks, AuthorToolbar, CategoryNav, LocalVersionBanner }
}

})